<template>
    <div class="changeNewPhone">
        <div class="changeNewPhone-input-item">
            <p class="chagneNewPhone-new-title">新手机号码</p>
            <div class="changePhone-code">
                <van-field v-model="phone" center clearable placeholder="请输入新手机号码">
                    <template #button>
                        <span class="sendCodeBtn" @click="sendCode">{{ sendCodeText }}</span>
                    </template>
                </van-field>
            </div>
            <p class="changeNewPhone-tips">新手机必须未绑定其他用户</p>
        </div>
        <div class="changeNewPhone-input-item">
            <p class="chagneNewPhone-new-title">短信验证码</p>
            <div class="changePhone-code">
                <van-field v-model="code" center clearable placeholder="请输入短信验证码">
                    <!-- <template #button>
                    <span class="sendCodeBtn" @click="sendCode">{{sendCodeText}}</span>
                </template> -->
                </van-field>
            </div>
        </div>
        <div class="changePhone-confirm-btn">
            <van-button class="comfirm-btn" :disabled="disabled" @click="confirmChange">更换手机号</van-button>
        </div>
    </div>
</template>

<script>
import { parseSmsKey } from "@/libs/parseData";
import rule from "@/libs/fieldValidateRules";
import { sendSmsApi } from "@/api/index";
import config from "@/config/index";
import { updatePhoneApi } from "@/api/index";
export default {
    name: "ChangeNewPhone",
    data() {
        return {
            phone: "",
            code: "",
            second: 60,
            timer: null,
            sendCodeText: "短信验证码",
        };
    },
    computed: {
        disabled() {
            if (this.code.length == 4 && this.phone != "") {
                return false;
            } else {
                return true;
            }
        },
    },
    methods: {
        sendCode() {
            if (!rule.phone.regex.test(this.phone)) {
                this.$toast("请输入正确的手机号码");
            } else if (this.second == 60) {
                let params = {
                    accessKey: config.accessKey,
                    accessToken: parseSmsKey(this.phone),
                    phoneNo: this.phone,
                };
                sendSmsApi(params).then((res) => {
                    this.timer = setInterval(() => {
                        if (this.second > 0) {
                            this.second -= 1;
                            this.sendCodeText = this.second + "s后重新获取";
                        } else {
                            this.sendCodeText = "获取短信验证码";
                            this.second = 60;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                    this.$notify({
                        message: "验证码已发送，请注意查收",
                        color: "#009AF3",
                        background: "#009AF333",
                    });
                });
            } else {
            }
        },
        confirmChange() {
            if (!rule.phone.regex.test(this.phone)) {
                this.$toast("请输入正确的手机号码");
            } else {
                let params = {
                    oldPhoneNo: this.$route.query.oldPhoneNo,
                    newPhoneNo: this.phone,
                    smsCode: this.code,
                };
                updatePhoneApi(params).then((res) => {
                    this.$store.dispatch("handleLogOut");
                    this.$router.push("/login");
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.comfirm-btn {
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.changeNewPhone {
    min-height: 100vh;
    background-color: #fff;
    padding-top: 124px;

    .changeNewPhone-input-item {
        padding: 0 72px;
        margin-bottom: 55px;

        .chagneNewPhone-new-title {
            font-size: 32px;
            font-weight: 500;
            color: #333333;
        }

        .changePhone-code {
            border-bottom: 1px solid #dbdada;
            padding-bottom: 34px;
            margin-top: 45px;

            .sendCodeBtn {
                color: @main-color;
                font-size: 28px;
            }
        }

        .changeNewPhone-tips {
            font-size: 24px;
            color: #ff961b;
            margin-top: 23px;
        }
    }

    .changePhone-confirm-btn {
        padding: 24px;
        // margin-top: ;
    }
}
</style>
<style lang="less">
.changePhone-code {
    .van-cell {
        padding: 0;
    }
}
</style>
